import PropTypes from "prop-types";
import { useCallback } from "react";
import { OFFER_TYPES } from "app/constants";
import { FormattedMessage } from "react-intl";
import { offerTypePropTypes } from "app/utils/propTypes";
import DurationLabel from "app/pages/.shared/DurationLabel";
import AmountContainer from "app/pages/.shared/AmountContainer.jsx";
import RadioFormik from "app/pages/.shared/form/RadioFormik";

const Duration = ({
	duration,
	minPrice,
	publicPrice,
	amountSuffix,
	productInfo = {},
	offerType,
	onChange = () => {},
	...props
}) => {
	const handleChange = useCallback(() => {
		onChange(duration);
	}, [duration]);

	return (
		<RadioFormik
			id={`duration-${duration}`}
			name="duration"
			value={String(duration)}
			toggle={handleChange}
			data-testid={props["data-testid"]}
		>
			<div className="duration__content ignore-react-onclickoutside">
				<div className="duration__label">
					<DurationLabel duration={duration} />
				</div>

				{minPrice && (
					<div className="duration__price">
						<AmountContainer
							amount={minPrice}
							prefix={<FormattedMessage id="offer.per.person.from.label" />}
							suffix={amountSuffix}
						/>
					</div>
				)}

				{publicPrice && (
					<div className="duration__price duration__public-price">
						<AmountContainer amount={publicPrice} suffix={amountSuffix} />
					</div>
				)}

				{productInfo.ul === true && offerType === OFFER_TYPES.FLIGHT_WITH_ACCOMMODATION && (
					<div className="duration__info">
						<FormattedMessage id="search.engine.departure.city.info.business.flight" />
					</div>
				)}
			</div>
		</RadioFormik>
	);
};

Duration.propTypes = {
	offerType: offerTypePropTypes,
	productInfo: PropTypes.object,
	amountSuffix: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
	duration: PropTypes.number,
	minPrice: PropTypes.number,
	publicPrice: PropTypes.number,
	field: PropTypes.object,
	"data-testid": PropTypes.string,
	onChange: PropTypes.func,
};

export default Duration;
